import {useApiIdConverter} from "~/composables/useApiIdConverter"
import {CATEGORY_ID_PREFIX} from "~/libs/constants/constants"

export const useForbiddenCategoryIds = () => {

  const getForbiddenCategoryIds = () => {
    const forbiddenCategoryIds = useRuntimeConfig().public?.forbiddenCategoryIds ? String(useRuntimeConfig().public?.forbiddenCategoryIds).split(',') : []
    const apiIdConverter = useApiIdConverter()

    return forbiddenCategoryIds.map((categoryId) => {
      return apiIdConverter.uuidToUlid(categoryId, CATEGORY_ID_PREFIX)
    })
  }

  return {
    getForbiddenCategoryIds,
  }
}
